import { Sun, Moon, Monitor } from 'lucide-react'
import { useTheme, type ThemePreference } from '@/hooks/useTheme'
import { Button } from '@/components/ui/button'

const OPTIONS: { value: ThemePreference; label: string; icon: typeof Sun }[] = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
]

export function ThemeToggle() {
  const { preference, setPreference } = useTheme()

  return (
    <div className="flex gap-1 bg-[var(--fl-surface-hover)] rounded-xl p-1 w-fit">
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <Button
          key={value}
          type="button"
          variant="ghost"
          onClick={() => setPreference(value)}
          className={[
            'h-auto gap-1.5 rounded-lg px-3 py-1.5 font-medium',
            preference === value
              ? 'bg-[var(--fl-surface)] text-[var(--fl-text-1)] shadow-sm'
              : 'text-[var(--fl-text-2)]',
          ].join(' ')}
        >
          <Icon size={14} />
          {label}
        </Button>
      ))}
    </div>
  )
}
